//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { AbstractDepartmentModel, AbstractDepartmentNavModel } from "@app/catalog-common";
import { PresenterRegistration } from "@app/shared";

@PresenterRegistration({
  types: [AbstractDepartmentNavModel]
})
@Component({
  selector: "department-nav-item",
  standalone: false,
  templateUrl: "./departments-nav-item.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepartmentsNavItemComponent<TDepartment extends AbstractDepartmentModel> {
  public data: WritableSignal<AbstractDepartmentNavModel<TDepartment>> =
    signal<AbstractDepartmentNavModel<TDepartment>>(null);

  public isActive = computed(() => {
    return this.data().items().some(item => item.isChecked());
  });
}
